import React from 'react'
import HRNavbar from '../../HR/HRNavbar';

const OnlineTransaction = () => {
    return (
        <div>
            <HRNavbar />
        </div>
    )
}

export default OnlineTransaction
